import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import moment from 'moment';
import { translate } from 'react-i18next';

import { padDecimals } from '../../service/market';

import cssVars from '../../styles/_variables';

const createTooltipFormatter = () => function formatter() {
    const dateFormat = moment(this.x).isSame(moment().startOf('year'), 'y') ?
        'D. MMMM' : 'DD.MM.YYYY';

    return (
        `<div class="tooltip-container">
            <div>
                <span>${moment(this.x).format(dateFormat)}</span>
            </div>
            <div>
                Sats: <span class="tooltip-value">
                    ${padDecimals(this.y)} ${this.point.currency}
                </span>
            </div>
        </div>`
    );
};

class HighchartsArea extends Component {
    static propTypes = {
        config: PropTypes.object.isRequired,
        className: PropTypes.string,
        t: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.renderGraph();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.config.series[0].data !== this.props.config.series[0].data) {
            this.renderGraph();
        }
    }

    getGraphInstance() {
        return this.instance;
    }

    renderGraph() {
        const t = this.props.t;

        Highcharts.setOptions({
            lang: {
                decimalPoint: ',',
                months: t('months', { returnObjects: true }),
                weekdays: t('weekdays', { returnObjects: true }),
                shortMonths: t('shortMonths', { returnObjects: true }),
                shortWeekdays: t('shortWeekdays', { returnObjects: true }),
                noData: t('common:noData'),
            },
        });

        this.instance = Highcharts.chart(this.container, this.props.config);
    }

    render() {
        return (
            <div
                className={this.props.className}
                ref={(c) => { this.container = c; }}
            />
        );
    }
}

export default translate('date', { withRef: true })(HighchartsArea);

export const defaultOptions = {
    colors: [cssVars['color-main-blue']],
    chart: {
        type: 'area',
        backgroundColor: null,
        spacing: [0, 0, 0, 0],
        margin: [0, 0, 0, 0],
        pinchType: false,
        style: {
            fontFamily: 'inherit',
        },
    },
    title: { style: { display: 'none' } },
    subtitle: { style: { display: 'none' } },
    legend: { enabled: false },
    credits: { enabled: false },
    plotOptions: {
        series: {
            fillOpacity: 0.1,
            states: {
                hover: {
                    halo: false,
                    lineWidthPlus: 0,
                },
            },
            marker: {
                enabled: false,
            },
        },
    },
    tooltip: {
        animation: false,
        hideDelay: 0,
        followTouchMove: false,
        useHTML: true,
        shape: 'square',
        crosshairs: true,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        formatter: createTooltipFormatter(),
    },
    yAxis: {
        gridLineColor: cssVars['color-main-darker'],
        gridLineWidth: 1,
        endOnTick: false,
        title: {
            enabled: false,
        },
        labels: {
            enabled: false,
        },
    },
    xAxis: {
        type: 'datetime',
        gridLineWidth: 0,
        lineWidth: 0,
        tickColor: cssVars['color-border'],
        tickLength: 6,
        offset: 0,
        crosshair: {
            color: cssVars['color-border'],
            width: 1,
        },
        labels: {
            y: -6,
            style: {
                color: cssVars['color-graph-labels'],
                fontSize: '9px',
            },
        },
    },
};



/** WEBPACK FOOTER **
 ** /src/shared/components/graph/HighchartsArea.js
 **/